import React, { useEffect, useState } from 'react';
import { UrgencyBar } from './components/UrgencyBar';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { WinterCombosBanner } from './components/WinterCombosBanner';
import { OffersSection } from './components/OffersSection';
import { PainSection } from './components/PainSection';
import { SolutionSection } from './components/SolutionSection';
import { DiscountBanner } from './components/DiscountBanner';
import { ProductsSection } from './components/ProductsSection';
import { CombosSection } from './components/CombosSection';
import { BenefitsSection } from './components/BenefitsSection';
import { ShippingSection } from './components/ShippingSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { AboutSection } from './components/AboutSection';
import { FAQSection } from './components/FAQSection';
import { LocationSection } from './components/LocationSection';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { ScrollToTop } from './components/ScrollToTop';
import { InstagramButton } from './components/InstagramButton';
export function App() {
  const [activeBrand, setActiveBrand] = useState<string | null>(null);
  useEffect(() => {
    document.title = 'AlphaFit';
  }, []);
  return <div className="min-h-screen bg-dark-900 text-[#f0f0f0] font-sans overflow-x-hidden selection:bg-alphaGold selection:text-white" data-id="element-0" data-mp="82jt1oitsae">
      <UrgencyBar data-id="element-1" data-mp="33m5b01uz1i7a" />
      <Navbar onBrandFilter={setActiveBrand} data-id="element-2" data-mp="33nq73vwxp979" />
      <main data-id="element-3" data-mp="33oi337ug18y2">
        <HeroSection data-id="element-4" data-mp="38lrqkhy9vaj9" />
        <WinterCombosBanner data-id="element-5" data-mp="38l8f9k34nke7" />
        <OffersSection data-id="element-6" data-mp="38k6tolohjfi8" />
        <PainSection data-id="element-7" data-mp="38nupjrheke04" />
        <SolutionSection data-id="element-8" data-mp="3dkl3o99ncziw" />
        <DiscountBanner data-id="element-9" data-mp="3dl4jnkfqldua" />
        <ProductsSection activeBrand={activeBrand} onBrandFilter={setActiveBrand} data-id="element-10" data-mp="3dmfo7mh0apmg" />
        <CombosSection data-id="element-11" data-mp="nvanjf6awtab" />
        <BenefitsSection data-id="element-12" data-mp="sunas11342df" />
        <ShippingSection data-id="element-13" data-mp="stuexv3nyxa2" />
        <TestimonialsSection data-id="element-14" data-mp="st2heeqiaph5" />
        <AboutSection data-id="element-15" data-mp="swgk5o3310p4" />
        <FAQSection data-id="element-16" data-mp="3686fj9n0kvj" />
        <LocationSection data-id="element-17" data-mp="35gkz19r83iz" />
        <FinalCTA data-id="element-18" data-mp="34x4zq3nzp7l" />
      </main>
      <Footer data-id="element-19" data-mp="3uct43lu76r1j" />
      <InstagramButton data-id="element-20" data-mp="3ud1e95yxri91" />
      <ScrollToTop data-id="element-21" data-mp="3ubrgyizwqe3g" />
    </div>;
}